function fetchAndRenderProducts(handle) {
  window.scrollTo(0, 0);
  const loader = document.querySelector('.page-loader');
  const subCollectionList = document.querySelector('.sub_collection-list');
  if (subCollectionList) {
    subCollectionList.style.display = 'none';
  }
  loader.style.display = 'block';

  const url = `/collections/${handle}?view=ajax`;
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const container = document.getElementById('product-container');
      const urlParams = new URLSearchParams(window.location.search);
      let mainHandle = urlParams.get('main-cate');

      if (container) {
        // Parse the HTML into a temporary DOM
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Update buttons if mainHandle is 'accessoires' or 'stockage'
        if (mainHandle === 'accessoires' || mainHandle === 'stockage') {
          const buttons = tempDiv.querySelectorAll('.quick-add__submit');
          buttons.forEach(button => {
            button.setAttribute('data-type', mainHandle);
          });
        }
        if(handle !== 'accessoires' || handle === 'stockage'){
          const pageurl = new URL(window.location.href);
          if (pageurl.searchParams.has('main-cate')) {
            console.log('url', pageurl);
            pageurl.searchParams.delete('main-cate');
            window.history.replaceState({}, '', pageurl.toString());
          }
        }

        // Clear and insert updated HTML
        container.innerHTML = '';
        container.appendChild(tempDiv);
      }

      highlightSelectedRows();
      initSearchFunctionality();
      sortSearchResults();
      filterRows();
      loader.style.display = 'none';
    })
    .catch(err => {
      console.error('Error loading collection:', err);
    });
}

function fetchCollection(handle) {
  window.scrollTo(0, 0);
  const loader = document.querySelector('.page-loader')
  const subCollectionList = document.querySelector('.sub_collection-list')
  if (subCollectionList){
    subCollectionList.style.display = 'block';
  }
  loader.style.display = 'block';
  const url = `/collections/${handle}?view=collection-meta-json`;
  fetch(url)
    .then(res => res.json())
    .then(data => {
      const container = document.getElementById('product-container');
      if (container) {
        container.innerHTML = '';
      }

      const csurl = new URL(window.location);

      if (handle === 'accessoires' || handle === 'stockage') {
        csurl.searchParams.set('main-cate', data.collection?.handle);
      } else {
        csurl.searchParams.delete('main-cate'); // Optional: clean up for other categories
      }
      window.history.pushState({}, '', csurl);


      const subCollectionList = document.querySelector('.sub_collection-list ul');
      const collectiontitle = document.querySelector('.sub_collection-list h3');
      const subCollections = data.collection?.metafields?.['theme.sub_collections'];
  
      if (collectiontitle) {
        collectiontitle.innerHTML = data.collection?.title || '';
      } else {
        console.warn('No <h3> found inside .sub_collection-list');
      }

      if (subCollectionList && Array.isArray(subCollections)) {
        subCollectionList.innerHTML = ''; // Clear existing items
        subCollections.forEach(sub => {
          const li = document.createElement('li');
          li.innerHTML = `
            <a class="category-btn" href="javascript:void(0)" data-handle="${sub.handle}">
              <img src="${sub.image?.src}" alt="${sub.title}" width="100" />
              <p>${sub.title}</p>
            </a>
          `;
          subCollectionList.appendChild(li);
        });
      }
      loader.style.display = 'none';
    })
    .catch(err => {
      console.error('Error loading collection:', err);
    });
}

// On button click, update only the `cate` parameter, preserve others
document.querySelectorAll('.category-btn').forEach(button => {
  button.addEventListener('click', function () {
    // Close drawers
    document.querySelectorAll(".prod_drawer.open").forEach(d => d.classList.remove('open'));
    document.querySelectorAll(".drawer-overlay.show").forEach(d => d.classList.remove('show'));
    document.querySelectorAll('.category-btn').forEach(btn => btn.classList.remove('active'));
    document.body.classList.remove("overflow-hidden");
    this.classList.add('active');
    const handle = this.getAttribute('data-handle');
    const url = new URL(window.location);

    url.searchParams.set('cate', handle); // Only update/add `cate`
    window.history.pushState({}, '', url);
    if(handle === 'accessoires' || handle === 'stockage'){
      fetchCollection(handle);
    }else{
      fetchAndRenderProducts(handle);
    }
  });
});

// On page load: get `cate`, or fallback to default
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/pages/shop')) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  let handle = urlParams.get('cate');

  if (!handle) {
    handle = 'cpu';
    const url = new URL(window.location);
    url.searchParams.set('cate', handle);
    window.history.replaceState({}, '', url);
  }
  if(handle){
    const matchingBtn = document.querySelector(`.category-btn[data-handle="${handle}"]`);
    if (matchingBtn) {
      // Remove existing active classes
      document.querySelectorAll('.category-btn').forEach(btn => btn.classList.remove('active'));
      // Set active to matching button
      matchingBtn.classList.add('active');
    }
  }
  if(handle === 'accessoires' || handle === 'stockage'){
    fetchCollection(handle);
  }else{
    fetchAndRenderProducts(handle);
  }
});

document.querySelector('.sub_collection-list').addEventListener('click', function (e) {
  const button = e.target.closest('.category-btn');
  if (button) {
    // Close drawers
    document.querySelectorAll(".prod_drawer.open").forEach(d => d.classList.remove('open'));
    document.querySelectorAll(".drawer-overlay.show").forEach(d => d.classList.remove('show'));

    const handle = button.getAttribute('data-handle');
    const url = new URL(window.location);

    url.searchParams.set('cate', handle); // Only update/add `cate`
    window.history.pushState({}, '', url); // Update URL without reloading
    if (handle === 'accessoires' || handle === 'stockage') {
      fetchCollection(handle);
    } else {
      fetchAndRenderProducts(handle);
    }
  }
});

window.addEventListener('popstate', () => {
  const handle = new URLSearchParams(window.location.search).get('cate');
  if (handle) {
    if(handle === 'accessoires' || handle === 'stockage'){
      fetchCollection(handle);
    }else{
      fetchAndRenderProducts(handle);
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const drawer = document.querySelector(".right-drawer");
  const drawerOverlay = document.querySelector(".drawer-overlay");
  const toggleButtons = document.querySelectorAll(".drawer-toggle");
  const closeDrawer = document.querySelector(".drawer-close");
  toggleButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      const supportBtn = document.querySelector("#shopify-chat");
      if (supportBtn) supportBtn.classList.add('d-none');
      drawer.classList.toggle("open");
      drawerOverlay.classList.toggle("show")
      document.body.classList.toggle("overflow-hidden");
    });
  });
  closeDrawer.addEventListener("click", function() {
    const supportBtn = document.querySelector("#shopify-chat");
    if (supportBtn) supportBtn.classList.remove('d-none');
    drawer.classList.remove("open");
    drawerOverlay.classList.remove("show");
    document.body.classList.remove("overflow-hidden");
    supportBtn.classList.remove('d-none');
  });
  drawerOverlay.addEventListener("click", function() {
    const supportBtn = document.querySelector("#shopify-chat");
    if (supportBtn) supportBtn.classList.remove('d-none');
    drawer.classList.remove("open");
    drawerOverlay.classList.remove("show");
    document.body.classList.remove("overflow-hidden");
    supportBtn.classList.remove('d-none');
  });
});

const formatPrice = (value) => {
  const price = Math.floor(Number(value || 0));
  return price.toLocaleString('de-DE');
};

function calculateTotalPrice(unitPrice, quantity) {
  const cleanedPrice = unitPrice.replace(/,/g, ''); // Remove commas
  const priceNum = parseFloat(cleanedPrice);
  const qtyNum = parseInt(quantity, 10);
  if (isNaN(priceNum) || isNaN(qtyNum)) return '';
  const total = priceNum * qtyNum;
  return formatPrice(total); 
}

function checkCart(){
  const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  if (Object.keys(cart).length > 0) {
    document.querySelector('.copy-url').style.display = 'block';
  } else {
    document.querySelector('.copy-url').style.display = 'none';
  }
}

function renderQuickAddCart(cartData) {
  if (!cartData || typeof cartData !== 'object') return;
  Object.keys(cartData).forEach(type => {
    const productList = cartData[type];
    const row = document.getElementById(type);
    if (!row) return;
    const isMulti = row.classList.contains('multi-prodRow');
    const listContainer = row.querySelector('.multi-prod_list');
    const selectBtn = row.querySelector('.selectProd');
    if (isMulti && listContainer) {
      listContainer.querySelectorAll('li:not(:last-child)').forEach(li => li.remove());
      if (!productList || productList.length === 0) {
        listContainer.classList.add('d-none');
        if (selectBtn) selectBtn.classList.remove('d-none');
        return;
      }
      listContainer.classList.remove('d-none');
      if (selectBtn) selectBtn.classList.add('d-none');
      productList.forEach(product => {
        const li = document.createElement('li');
        li.innerHTML = `
          <div class="product-details">
            <div class="prod_meta">
              <div class="drawr-img">
                <img src="${product.image}" alt="${product.name}">
              </div>
              <p class="mb-0 text-muted">${product.name}</p>
            </div>
          </div>
          <div class="quantity-control show" data-variantid="${product.variantId}">
            <button class="btn decrease" type="button">−</button>
            <span class="quantity-value">${product.quantity || 1}</span>
            <button class="btn increase" type="button">+</button>
          </div>
          <p class="mb-0 price">${calculateTotalPrice(product.price, product.quantity || '1')} ${currencySymbol}</p>
          <button class="btn btn-link text-danger deleteProd show" type="button" data-variant="${product.variantId}">
            <img src="https://cdn.shopify.com/s/files/1/0684/7322/5353/files/Vector_4.png?v=1744016676" alt="Delete Icon">
          </button>
          <a class="btn btn-outline-primary ms-auto selectProd d-none" href="">+ Select</a>
        `;
        listContainer.insertBefore(li, listContainer.lastElementChild);
      });
    } else {
      const product = productList[0];
      const imageContainer = row.querySelector('.drawr-img');
      const description = row.querySelector('.prod_meta p.text-muted');
      const priceTag = row.querySelector('.price');
      const quantityField = row.querySelector('.quantity-control'); // Get the .prod_meta element
      const quantityShowField = row.querySelector('.quantity-value'); // Get the .prod_meta element
      if (imageContainer) imageContainer.innerHTML = `<img src="${product.image}" alt="${product.name}">`;
      if (description) description.textContent = product.name;
      if (priceTag) priceTag.textContent = calculateTotalPrice(product.price, product.quantity || '1') + ' ' + currencySymbol;
      if (selectBtn) selectBtn.classList.add('d-none');
      if (quantityField) quantityField.dataset.variantid = product.variantId;
      if (quantityShowField) quantityShowField.textContent = product.quantity || '1';
      const quantityCtrlBtn = row.querySelector('.quantity-control');
      if (quantityCtrlBtn) quantityCtrlBtn.classList.add('show');
      const deletedProd = row.querySelector('.deleteProd');
      if (deletedProd) deletedProd.classList.add('show');
    }
  });
  // Hide unused multi-prod rows
  document.querySelectorAll('.multi-prodRow').forEach(row => {
    const id = row.id;
    const listContainer = row.querySelector('.multi-prod_list');
    const selectBtn = row.querySelector('.selectProd');
    if (!cartData[id] || cartData[id].length === 0) {
      if (listContainer) listContainer.classList.add('d-none');
      if (selectBtn) selectBtn.classList.remove('d-none');
    }
  });
  document.querySelectorAll('.multi-prodRow').forEach(row => {
    const id = row.id;
    const listContainer = row.querySelector('.multi-prod_list');
    const selectBtn = row.querySelector('.selectProd');
    if (!cartData[id] || cartData[id].length === 0) {
      if (listContainer) listContainer.classList.add('d-none');
      if (selectBtn) selectBtn.classList.remove('d-none');
    }
  });
}

function initializeQuickAddCart() {
  const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  renderQuickAddCart(cart);
  checkCart();
}

document.addEventListener('DOMContentLoaded', initializeQuickAddCart);

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const prebuiltParam = urlParams.get('prebuilt');
  const store = 'custom-pc-builder-s.myshopify.com';
  checkCart();
  if (prebuiltParam) {
    try {
      const apiUrl = `https://pcbuilder.webgarh.net/api/products/metaobject?store=${store}&handle=${prebuiltParam}`;
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          const builtData = data?.data?.fields[0]?.jsonValue;
          // Remove existing quickAddCart if present
          if (localStorage.getItem('quickAddCart')) {
            localStorage.removeItem('quickAddCart');
          }
          if(builtData){
            renderQuickAddCart(builtData);
          }
          localStorage.setItem('quickAddCart', JSON.stringify(builtData));
          if (localStorage.getItem('quickAddCart')) {
            highlightSelectedRows();
            updateCartSummary();
            showTotalWattage();
          }
        })
        .catch(err => {
          console.error("GET API call failed:", err);
        });
    } catch (error) {
      console.error("Error decoding prebuilt UID:", error);
    }
  }
});

document.addEventListener('click', function (e) {
  const button = e.target.closest('.quick-add__submit');
  if (!button) return;
  const row = button.closest('tr');
  if (!row) return;
  let componentType = button.dataset.type?.trim().toLowerCase() || 'other';
  componentType = componentType.replace(/\s+/g, '_');
  const image = row.querySelector('.media--transparent img')?.getAttribute('src') || '';
  const name = row.querySelector('.pro_detail h3 a')?.textContent.trim() || '';
  const price = row.querySelector('.product-pricing .discounted')?.textContent.trim() ||
                row.querySelector('.product-pricing .product-compare-at-price')?.textContent.trim() ||
                row.querySelector('.product-pricing .product-price')?.textContent.trim() || '';
  const variantId = row.getAttribute('data-id') || '';
  const wattage = row.getAttribute('data-wattage') || '';    
  const productData = { name, image, price, variantId, wattage };
  let cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  cart[componentType] = cart[componentType] || [];
  const singleSelectTypes = ['processeur(cpu)', 'cartemere', 'cartegraphique', 'alimentation', 'ventilateurcpu', 'boitierpc',];
  const isSingle = singleSelectTypes.includes(componentType);
  if (isSingle) {
    cart[componentType] = [productData];
  } else {
    const productExists = cart[componentType].some(item => item.variantId === productData.variantId);
    if (!productExists) {
      cart[componentType].push(productData);
    }
  }
  localStorage.setItem('quickAddCart', JSON.stringify(cart));
  const normalizedId = componentType;
  const targetRow = document.getElementById(normalizedId);
  if (!targetRow) return;
  const isMulti = targetRow.classList.contains('multi-prodRow');
  if (isMulti) {
    const list = targetRow.querySelector('.multi-prod_list');
    const addBtn = list.querySelector('li:last-child');
    const productExistsInDOM = [...list.querySelectorAll('li')]
  .some(li => li.querySelector('.deleteProd')?.dataset.variant === productData.variantId);
if (!productExistsInDOM) {
  // Show the list if it was hidden
  if (list.classList.contains('d-none')) {
    list.classList.remove('d-none');
  }
  // Hide the "+ Select" button
  const selectBtn = targetRow.querySelector('.selectProd');
  if (selectBtn) {
    selectBtn.classList.add('d-none');
  }
  const li = document.createElement('li');
  li.innerHTML = `
    <div class="product-details">
      <div class="prod_meta">
        <div class="drawr-img">
          <img src="${productData.image}" alt="${productData.name}">
        </div>
        <p class="mb-0 text-muted">${productData.name}</p>
      </div>
    </div>
    <div class="quantity-control show" data-variantid="${productData.variantId}">
      <button class="btn decrease" type="button">−</button>
      <span class="quantity-value">1</span>
      <button class="btn increase" type="button">+</button>
    </div>
    <p class="mb-0 price">${calculateTotalPrice(productData.price, productData.quantity || '1')} &nbsp; ${currencySymbol}</p>
    <button class="btn btn-link text-danger deleteProd show" type="button" data-variant="${productData.variantId}">
      <img src="https://cdn.shopify.com/s/files/1/0684/7322/5353/files/Vector_4.png?v=1744016676" alt="Delete Icon">
    </button>
    <a class="btn btn-outline-primary ms-auto selectProd d-none" href="">+ Select</a>
  `;
  list.insertBefore(li, addBtn);
}
} else {
    const imageContainer = targetRow.querySelector('.drawr-img');
    if (imageContainer) {
      imageContainer.innerHTML = `<img src="${productData.image}" alt="${productData.name}">`;
    }
    const description = targetRow.querySelector('#prod-description') || targetRow.querySelector('p.text-muted');
    if (description) {
      description.textContent = productData.name;
    }
    const priceContainer = targetRow.querySelector('.price');
    if (priceContainer) {
      priceContainer.textContent = calculateTotalPrice(productData.price, productData.quantity || '1') + '' + currencySymbol;
    }
    const selectBtn = targetRow.querySelector('.selectProd');
    if (selectBtn) {
      selectBtn.classList.add('d-none');
    }
    const quantityCtrl = targetRow.querySelector('.quantity-control');
    if (quantityCtrl) {
      quantityCtrl.classList.add('show');
    }
    const deleteProd = targetRow.querySelector('.deleteProd');
    if (deleteProd) {
      deleteProd.classList.add('show');
      deleteProd.dataset.variant = productData.variantId;
    }
    const quantityField = targetRow.querySelector('.quantity-control');
    if (quantityField) quantityField.dataset.variantid = productData.variantId;
  }
  highlightSelectedRows();
  checkCart();
  const supportBtn = document.querySelector("#shopify-chat");
  if (supportBtn) supportBtn.classList.add('d-none');
  const drawer = document.querySelector(".right-drawer");
  const drawerOverlay = document.querySelector(".drawer-overlay");
  setTimeout(() => {
    drawer.classList.toggle("open");
    drawerOverlay.classList.toggle("show");
  }, 500);
  showTotalWattage();
});

document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get("openDrawer") === "true") {
    const drawer = document.querySelector(".right-drawer");
    const drawerOverlay = document.querySelector(".drawer-overlay");
    setTimeout(() => {
      drawer.classList.toggle("open");
      drawerOverlay.classList.toggle("show");
      document.body.classList.toggle("overflow-hidden");
    }, 500);
  }
});

document.addEventListener('click', function (e) {
  const deleteBtn = e.target.closest('.deleteProd');
  if (!deleteBtn) return;
  const row = deleteBtn.closest('.product-row');
  if (!row || !row.id) return;
  const componentType = row.id.toLowerCase();
  const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  const isMulti = row.classList.contains('multi-prodRow');
  const variantId = deleteBtn.dataset.variant;
  const quantityShowField = row.querySelector('.quantity-value');
  if (quantityShowField) quantityShowField.textContent = '1';
  if (isMulti) {
    // Remove from localStorage
    if (cart[componentType]) {
      cart[componentType] = cart[componentType].filter(item => item.variantId !== variantId);
      if (cart[componentType].length === 0) {
        delete cart[componentType];
      }
      localStorage.setItem('quickAddCart', JSON.stringify(cart));
    }
    const list = row.querySelector('.multi-prod_list');
    const liToRemove = [...list.querySelectorAll('li')].find(li =>
      li.querySelector('.deleteProd')?.dataset.variant === variantId
    );
    if (liToRemove) liToRemove.remove();
    // Check remaining real items (exclude "Add Additional" button)
    const remainingItems = [...list.querySelectorAll('li')]
      .filter(li => !li.querySelector('.add-more_prod') && li.querySelector('.deleteProd'));
    if (remainingItems.length === 0) {
      list.classList.add('d-none');
      const selectBtn = row.querySelector('.selectProd');
      if (selectBtn) selectBtn.classList.remove('d-none'); // Show +Select
    }
  } else {
    // Single product row delete logic
    if (cart[componentType]) {
      delete cart[componentType];
      localStorage.setItem('quickAddCart', JSON.stringify(cart));
    }
    const imageContainer = row.querySelector('.drawr-img');
    if (imageContainer) imageContainer.innerHTML = '';
    const description = row.querySelector('#prod-description') || row.querySelector('p.text-muted');
    if (description) description.textContent = '';
    const priceContainer = row.querySelector('.price');
    if (priceContainer) priceContainer.textContent = '';
    const selectBtn = row.querySelector('.selectProd');
    if (selectBtn) selectBtn.classList.remove('d-none');
    const quantityCtrlBtn = row.querySelector('.quantity-control');
    if (quantityCtrlBtn) quantityCtrlBtn.classList.remove('show');
    const deletedProd = row.querySelector('.deleteProd');
    if (deletedProd) deletedProd.classList.remove('show');
  }
  highlightSelectedRows();
  checkCart();
});

document.addEventListener("DOMContentLoaded", function () {
const resetButton = document.getElementById("resetDrawer");
  if (resetButton) {
    resetButton.addEventListener("click", function () {
      localStorage.removeItem("quickAddCart");
      const productDetails = document.querySelectorAll(".product-details");
      productDetails.forEach(function (detail) {
        detail.innerHTML = `
          <div class="prod_meta">
            <div class="drawr-img"></div>
            <p id="prod-description" class="mb-0 text-muted"></p>
          </div>
        `;
      });
      // Reset quantity and price displays
      const quantitySpans = document.querySelectorAll(".quantity");
      quantitySpans.forEach(function (span) {
        span.textContent = "0";
      });
      const quantityShowField = document.querySelectorAll('.quantity-value');
      quantityShowField.forEach(el => {
        el.textContent = '1';
      });
      const priceDisplays = document.querySelectorAll(".right-drawer .price");
      priceDisplays.forEach(function (price) {
        price.textContent = "";
      });
      // Hide quantity-control, price, and deleteProd if product-details are empty
      const allDetailsEmpty = Array.from(productDetails).every(
        (detail) => detail.innerHTML.trim() === ""
      );
      const quantityControls = document.querySelectorAll(".quantity-control");
      quantityControls.forEach((el) => el.classList.remove("show"));
      const deleteButtons = document.querySelectorAll(".deleteProd");
      deleteButtons.forEach((btn) => btn.classList.remove("show"));
      document.querySelectorAll(".selectProd").forEach((btn) => btn.classList.remove("d-none"));
      // Update cart item count and total price
      document.getElementById("cart-item-count").textContent = "(0 Items)";
      document.getElementById("cart-total-price").textContent = "0.00" + '' + currencySymbol;
      document.querySelectorAll('.multi-prod_list').forEach(list => {
        const lis = list.querySelectorAll('li');
        lis.forEach((li, index) => {
            if (index < lis.length - 1) {
            li.remove();
            }
        });
        list.classList.add('d-none'); // Hide the list again
      });
      highlightSelectedRows();
      checkCart();
      showTotalWattage();
      updateCartSummary();
      const drawer = document.querySelector(".right-drawer");
      const drawerOverlay = document.querySelector(".drawer-overlay");
      document.body.classList.remove("overflow-hidden");
      drawer.classList.remove("open");
      drawerOverlay.classList.remove("show");
      history.pushState(null, "", "https://custom-pc-builder-s.myshopify.com/collections/computer-processors");
    });
  }
});

function highlightSelectedRows() {
  const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  const selectedVariantIds = [];
  Object.values(cart).forEach(items => {
    items.forEach(item => {
      selectedVariantIds.push(item.variantId);
    });
  });
  document.querySelectorAll('tr[data-id]').forEach(tr => {
    const variantId = tr.getAttribute('data-id');
    const isSelected = selectedVariantIds.includes(variantId);
    tr.classList.toggle('selected', isSelected);
    const addBtn = tr.querySelector('.quick-add__submit');
    if (addBtn) {
      addBtn.disabled = isSelected;
      addBtn.classList.toggle('disabled', isSelected);
      addBtn.textContent = isSelected ? 'Selected' : '+ Select';
    }
  });
  selectedVariantIds.forEach(variantId => {
    const tr = document.querySelector(`tr[data-id="${variantId}"]`);
    if (tr) {
      tr.classList.add('selected');
    }
  });
}

document.addEventListener('DOMContentLoaded', highlightSelectedRows);

document.addEventListener('click', function (e) {
  const isIncreaseBtn = e.target.closest('.increase');
  const isDecreaseBtn = e.target.closest('.decrease');
  if (!isIncreaseBtn && !isDecreaseBtn) return;
  const quantityWrapper = e.target.closest('.quantity-control');
  const quantityEl = quantityWrapper.querySelector('.quantity-value');
  let quantity = parseInt(quantityEl.textContent, 10);
  const variantId = e.target.closest('.quantity-control')?.dataset.variantid;
  // Determine if increasing or decreasing
  if (isIncreaseBtn) {
    quantity += 1;
  } else if (isDecreaseBtn && quantity > 1) {
    quantity -= 1;
  }
  quantityEl.textContent = quantity;
  // Update localStorage
  let cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  for (let type in cart) {
    cart[type] = cart[type].map(prod => {
      if (prod.variantId === variantId) {
        return { ...prod, quantity: quantity.toString() };
      }
      return prod;
    });
  }
  localStorage.setItem('quickAddCart', JSON.stringify(cart));
  initializeQuickAddCart();
  updateCartSummary();
});

document.addEventListener('DOMContentLoaded', function () {
  const addAllBtn = document.getElementById('addAllToCart');
  addAllBtn.addEventListener('click', function () {
    const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
    const items = [];
    Object.values(cart).flat().forEach(product => {
      if (product.variantId) {
        items.push({
          id: parseInt(product.variantId, 10),
          quantity: parseInt(product.quantity, 10),
        });
      }
    });
    if (items.length === 0) {
      console.log('No products to add.');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(() => {
      localStorage.removeItem('quickAddCart');
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error adding products:', error);
      console.log('Something went wrong. Please try again.');
    });
  });
});

function updateCartSummary() {
  const formatPrice = (value) => {
    const price = Math.floor(Number(value || 0));
    return price.toLocaleString('de-DE');
  }
  const cart = JSON.parse(localStorage.getItem('quickAddCart')) || {};
  let totalItems = 0;
  let totalPrice = 0;
  Object.values(cart).flat().forEach(product => {
    const quantity = parseInt(product.quantity, 10) || 1;
    totalItems += quantity;
    // Parse price string (e.g. "$2,585.93" to 2585.93)
    const price = parseFloat(
      product.price.replace(/[^0-9.]/g, '').replace(/,/g, '')
    );
    if (!isNaN(price)) {
      totalPrice += price * quantity;
    }
  });
  document.getElementById('cart-item-count').textContent = `(${totalItems} Item${totalItems !== 1 ? 's' : ''})`;
  document.getElementById('cart-total-price').textContent = `${formatPrice(totalPrice)}` + ' ' + currencySymbol;
  document.getElementById('totalAmountSpan').textContent = `${formatPrice(totalPrice)}` + ' ' + currencySymbol;
}

document.addEventListener('DOMContentLoaded', updateCartSummary);
 
document.addEventListener('click', function (e) {
  if (e.target.closest('.quick-add__submit')) {
    setTimeout(updateCartSummary, 100); // Delay just to let localStorage update
  }
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.deleteProd')) {
    setTimeout(updateCartSummary, 100); // Delay just to let localStorage update
  }
});

function getTotalWattage() {
  const quickAddCart = JSON.parse(localStorage.getItem("quickAddCart")) || {};
  let totalWattage = 0;
  Object.values(quickAddCart).forEach(category => {
    category.forEach(item => {
      const watt = parseInt(item.wattage); // safely parse wattage
      if (!isNaN(watt)) {
        totalWattage += watt;
      }
    });
  });
  return totalWattage;
}

// Show total in all relevant divs

function showTotalWattage() {
  const total = getTotalWattage();
  const wattageDisplays = document.querySelectorAll(".draw-head-inner, .draw-head-inner1, .draw-head-inner2");

  wattageDisplays.forEach(div => {
    div.innerText = `Total Wattage: ${total}W`;
  });
}

document.addEventListener("DOMContentLoaded", showTotalWattage);

//   document.querySelectorAll('.pc_items-list a').forEach(function(link) {
//     link.addEventListener('click', function(event) {
//       event.preventDefault(); // Prevent default link behavior

//       const sectionId = this.getAttribute('href').split('/')[2]; // Extract the section ID from the URL (e.g., 'ram' or 'processor')
//       const productSection = document.querySelector(`#${sectionId}`); // Find the corresponding product section

//       // Hide all product sections
//       document.querySelectorAll('.product-section').forEach(function(section) {
//         section.style.display = 'none';
//       });

//       // Show the selected product section
//       if (productSection) {
//         productSection.style.display = 'block';
//       }

//       // Update the URL to reflect the selected section with the hash
//       window.history.pushState({}, '', `https://lahlou-industrie.com/pages/shop/#${sectionId}`);
//     });
//   });

function initSearchFunctionality() {
  const searchInput = document.querySelector(".ai-search-button input[type='text']");
  const searchButton = document.querySelector(".ai-search-button button");
  const tableBody = document.querySelector("#pro_detail_id");

  if (!searchInput || !searchButton || !tableBody) return;

  const tableRows = tableBody.querySelectorAll("tr");

  function filterRows() {
    const query = searchInput.value.trim().toLowerCase();
    tableRows.forEach(row => {
      const productNameElement = row.querySelector("h3 a");
      const productName = productNameElement ? productNameElement.textContent.toLowerCase() : "";

      row.style.display = productName.includes(query) ? "" : "none";
    });
  }

  function showAllRows() {
    tableRows.forEach(row => row.style.display = "");
  }

  // Filter only on button click
  searchButton.addEventListener("click", filterRows);

  // If input becomes empty, show all results immediately
  searchInput.addEventListener("input", function () {
    if (searchInput.value.trim() === "") {
      showAllRows();
      console.log("Input cleared — all rows shown.");
    }
  });
}

function sortSearchResults(withSearch = false) {
  const headers = document.querySelectorAll('.sortable');
  const tbodySelector = 'pro_detail_id';
  const tbody = document.getElementById(tbodySelector);
  setTimeout(() => {
    document.querySelectorAll(`#${tbodySelector} tr`).forEach(row => {
      const ratingSpan = row.querySelector('.loox-rating-label');

      if (ratingSpan) {
        const match = ratingSpan.textContent.match(/\((\d+)\)/);
        const ratingValue = match ? match[1] : "0";
        row.dataset.rating = ratingValue;
      }
    });
  }, 1000);
  headers.forEach(header => {
    header.addEventListener('click', function () {

      const tbodySelector = 'pro_detail_id';
      const tbody = document.getElementById(tbodySelector);
      const sortKey = header.dataset.sort;
      const isAsc = !header.classList.contains('asc');

      headers.forEach(h => h.classList.remove('asc', 'desc'));
      header.classList.add(isAsc ? 'asc' : 'desc');

      const rows = Array.from(tbody.querySelectorAll('tr'));

      rows.sort((a, b) => {
        const aVal = (a.dataset[sortKey] || '').toString().trim().toLowerCase();
        const bVal = (b.dataset[sortKey] || '').toString().trim().toLowerCase();

        const aNum = parseFloat(aVal);
        const bNum = parseFloat(bVal);

        if (!isNaN(aNum) && !isNaN(bNum)) {
          return isAsc ? aNum - bNum : bNum - aNum;
        }

        return isAsc ?
          aVal.localeCompare(bVal) :
          bVal.localeCompare(aVal);
      });

      tbody.innerHTML = '';
      rows.forEach(row => tbody.appendChild(row));
    });
  });
}



document.addEventListener("DOMContentLoaded", function () {
  const priceCheckboxes = document.querySelectorAll(".price-checkbox");
  const availabilityCheckboxes = document.querySelectorAll(".availability-checkbox");

  const urlParams = new URLSearchParams(window.location.search);
  const selectedPriceRanges = urlParams.get("price_range") ?.split(",") || [];
  const selectedAvailability = urlParams.get("availability") ?.split(",") || [];

  // Pre-check checkboxes
  priceCheckboxes.forEach(cb => {
    if (selectedPriceRanges.includes(cb.value)) cb.checked = true;
    cb.addEventListener("change", () => {
      // Uncheck all other price checkboxes
      priceCheckboxes.forEach(other => {
        if (other !== cb) other.checked = false;
      });
  
      updateURLWithFilters();
      filterRows();
    });
  });
  availabilityCheckboxes.forEach(cb => {
    if (selectedAvailability.includes(cb.value)) cb.checked = true;
    cb.addEventListener("change", () => {
      availabilityCheckboxes.forEach(other => {
        if (other !== cb) other.checked = false;
      });
      updateURLWithFilters();
      filterRows();
    });
  });

  // Event listeners
  [...priceCheckboxes, ...availabilityCheckboxes].forEach(cb => {
    cb.addEventListener("change", () => {
      updateURLWithFilters();
      filterRows();
    });
  });

  function updateURLWithFilters() {
    const selectedPrices = Array.from(priceCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const selectedStock = Array.from(availabilityCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    const params = new URLSearchParams(window.location.search);

    if (selectedPrices.length) {
      params.set("price_range", selectedPrices.join(","));
    } else {
      params.delete("price_range");
    }

    if (selectedStock.length) {
      params.set("availability", selectedStock.join(","));
    } else {
      params.delete("availability");
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }
});

function filterRows() {
  document.querySelector('.filters_area').classList.remove('show');
  document.querySelector('.drawer-overlay-filter').classList.remove('show');
  const priceCheckboxes = document.querySelectorAll(".price-checkbox");
  const availabilityCheckboxes = document.querySelectorAll(".availability-checkbox");

  const tableRows = document.querySelectorAll("#pro_detail_id tr");
  const priceRanges = Array.from(priceCheckboxes)
    .filter(cb => cb.checked)
    .map(cb => {
      const [min, max] = cb.value.split("-").map(Number);
      return {
        min,
        max
      };
    });

  const availabilityFilters = Array.from(availabilityCheckboxes)
    .filter(cb => cb.checked)
    .map(cb => cb.value);

  tableRows.forEach(row => {
    const price = parseFloat(row.dataset.price || "0");
    const stock = row.dataset.stock === "true" ? "in-stock" : "out-of-stock";

    const matchesPrice = priceRanges.length === 0 || priceRanges.some(range => price >= range.min && price <= range.max);
    const matchesStock = availabilityFilters.length === 0 || availabilityFilters.includes(stock);

    row.style.display = (matchesPrice && matchesStock) ? "" : "none";
  });
}

document.querySelector('.filter_mobile-btn button').addEventListener('click', function() {
  document.querySelector('.filters_area').classList.add('show');
  document.querySelector('.drawer-overlay-filter').classList.add('show');
}); 

document.querySelector('.drawer-overlay-filter').addEventListener('click', function() {
  document.querySelector('.filters_area').classList.remove('show');
  document.querySelector('.drawer-overlay-filter').classList.remove('show');
});

document.querySelector('.filters_area .close_filter').addEventListener('click', function() {
  document.querySelector('.filters_area').classList.remove('show');
  document.querySelector('.drawer-overlay-filter').classList.remove('show');
});


function setRealVh() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setRealVh();
window.addEventListener('resize', setRealVh);
